import api from './api';

const notificationService = {
  /**
   * Get user's notifications
   */
  async getNotifications({ limit = 50, offset = 0, unreadOnly = false } = {}) {
    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString(),
      unreadOnly: unreadOnly.toString(),
    });
    const response = await api.get(`/notifications?${params}`);
    return response.data.data;
  },

  /**
   * Get unread notification count
   */
  async getUnreadCount() {
    const response = await api.get('/notifications/unread-count');
    return response.data.data.unreadCount;
  },

  /**
   * Mark a notification as read
   */
  async markAsRead(notificationId) {
    const response = await api.put(`/notifications/${notificationId}/read`);
    return response.data.data;
  },

  /**
   * Mark all notifications as read
   */
  async markAllAsRead() {
    const response = await api.put('/notifications/read-all');
    return response.data;
  },

  /**
   * Delete a notification
   */
  async deleteNotification(notificationId) {
    const response = await api.delete(`/notifications/${notificationId}`);
    return response.data;
  },

  /**
   * Get notification preferences
   */
  async getPreferences() {
    const response = await api.get('/notifications/preferences');
    return response.data.data;
  },

  /**
   * Update notification preferences
   */
  async updatePreferences(preferences) {
    const response = await api.put('/notifications/preferences', preferences);
    return response.data.data;
  },

  /**
   * Send announcement to event attendees
   */
  async sendAnnouncement(eventId, title, message, sessionIds) {
    const payload = { title, message };
    if (sessionIds && sessionIds.length > 0) {
      payload.sessionIds = sessionIds;
    }
    const response = await api.post(`/notifications/events/${eventId}/announce`, payload);
    return response.data;
  },
};

export default notificationService;
